<template>
    <div class="kanban-category" tabindex="0" v-if="localValue">
        <div class="kanban-item" tabindex="0">
            <draggable v-model="localValue" @change="changed" :options="{animation:350}">
                <div class="card mb-1" v-for="(service, index) in localValue" :key="index">
                    <div class="card-body p-2">
                        <treatment-loop-item
                            draggable="true"
                            :deleteBundleItem="deleteBundleItem"
                            :index="index"
                            :removeItem="removeItem"
                            :service="service"
                        />
                    </div>
                </div>
            </draggable>
        </div>
    </div>
</template>

<script>
import TreatmentLoopItem from '@/components/TreatmentLoopItem';
import draggable from 'vuedraggable'
export default {
    props: ['value'],
    components: {
        draggable,
        TreatmentLoopItem,
    },
    data() {
        return {
            localValue: []

        }
    },
    watch: {
        value(newValue) {
            console.log('changed');
            this.localValue = newValue;
        }
    },
    created() {
        this.localValue = this.value;
    },

    methods: {
        removeItem(index) {
            this.value.splice(index, 1);
        },
        deleteBundleItem(itemIndex, bundleIndex) {
            this.value[itemIndex].bundle.splice(bundleIndex, 1);
        },
        changed() {
            console.log('changed');
            this.$emit('change', this.localValue);
            this.$emit('input', this.localValue);

        }
    }
}
</script>